// ✅ Declaración y exportación válidas
const mapCardsForPreview = (cards = [], globalHeaderType = "image", numButtons = 0, buttonTypes = []) => {
  const normalizedHeaderType = globalHeaderType?.toUpperCase() || "IMAGE";

  // 🧠 Si no hay cards, devolvemos un mock
  if (!cards || cards.length === 0) {
    const mockMedia =
      normalizedHeaderType === "VIDEO"
        ? "https://www.w3schools.com/html/mov_bbb.mp4"
        : "https://via.placeholder.com/300x180.png?text=Preview+Image";

    return [
      {
        headerType: normalizedHeaderType,
        mediaUrl: mockMedia,
        body: "Description",
        buttons: [
          {
            type: "QUICK_REPLY",
            text: "Button",
          },
        ],
      },
    ];
  }

  // 🧱 Mapeo normal si hay cards reales
  return cards.map((card) => {
    const cardHeaderType =
      card.headerType?.toUpperCase() ||
      normalizedHeaderType ||
      "IMAGE";

    const mediaUrl =
      card.file?.preview ||
      card.file?.url ||
      card.mediaUrl ||
      card.imageUrl ||
      card.fileUrl ||
      card.mediaPreview ||
      "";

    const body = card.description || card.body || "Description";

    // 🔘 Botones — leer desde campos indexados (button_0_title, button_1_title, etc.)
    const buttons = [];
    for (let i = 0; i < numButtons; i++) {
      const title = card[`button_${i}_title`]?.trim();
      if (!title) continue;
      const type = (buttonTypes[i] || "quick_reply").toUpperCase();
      buttons.push({ type, text: title });
    }

    // Fallback: si no hay botones por índice pero hay buttonType/buttonTitle legacy
    if (buttons.length === 0 && card.buttonType && card.buttonTitle) {
      buttons.push({
        type: card.buttonType.toUpperCase(),
        text: card.buttonTitle,
      });
    }

    // Fallback: buttons estructurados
    if (buttons.length === 0 && card.buttons?.length) {
      return {
        headerType: cardHeaderType,
        mediaUrl,
        body,
        buttons: card.buttons.map((b) => ({
          type: b.type?.toUpperCase() || "QUICK_REPLY",
          text: b.text || "Button",
        })),
      };
    }

    return { headerType: cardHeaderType, mediaUrl, body, buttons };
  });
};

export default mapCardsForPreview;
